import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import FindYourNextChapter from "./sections/FindYourNextChapter";
import AllAvailableUnits from "./sections/AllAvailableUnits";
import TheUrbanStandard from "./sections/TheUrbanStandard";
import ResidentExperiences from "./sections/ResidentExperiences";
import SeamlessMovingProcess from "./sections/SeamlessMovingProcess";
import ReadyToMove from "./sections/ReadyToMove";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <FindYourNextChapter />
      <AllAvailableUnits />
      <TheUrbanStandard />
      <ResidentExperiences />
      <SeamlessMovingProcess />
      <ReadyToMove />
      <Footer />
    </div>;
}